/**
 * The main api service
 */
import http from '@util/http';
import { incubator } from '@api/req';

export async function queryPayableCollection(params) {
  return http.get(incubator.INCU_PAYABLE_COLLECTION, params);
}

export async function queryPayableOverdue(params) {
  return http.get(incubator.INCU_PAYABLE_OVERDUE, params);
}

export async function queryPayableAbnormal(params) {
  return http.get(incubator.INCU_PAYABLE_ABNORMAL, params);
}

export async function queryPayablePending(params) {
  const url = params.customUuid ? incubator.CUSTOM_PENDING : incubator.INCU_PAYABLE_PENDING;
  return http.get(url, params);
}

export async function queryExportPayablePending(params = {}) {
  const url = params.customUuid
    ? incubator.CUSTOM_PENDING_EXPORT
    : incubator.INCU_PAYABLE_PENDING_EXPORT;
  http.download(url, params, '待付款账单导出.xlsx');
}

export async function queryPayablePaid(params) {
  const url = params.customUuid ? incubator.CUSTOM_PAID : incubator.INCU_PAYABLE_PAID;
  return http.get(url, params);
}

export async function queryPayablePaidDeposit(params) {
  const url = params.customUuid ? incubator.CUSTOM_PAID_DEPOSIT : incubator.PAYABLE_PAID_DEPOSIT;
  return http.get(url, params);
}

export async function queryPayablePaidLiquidate(params) {
  const url = params.customUuid
    ? incubator.CUSTOM_PAID_LIQUIDATE
    : incubator.PAYABLE_PAID_LIQUIDATE;
  return http.get(url, params);
}

export async function queryPayablePaidTurn(params) {
  const url = params.customUuid ? incubator.CUSTOM_PAID_TURN : incubator.PAYABLE_PAID_TURN;
  return http.get(url, params);
}

export async function queryPayablePaidTodo(params) {
  const url = params.customUuid ? incubator.CUSTOM_PAID_TODO : incubator.PAYABLE_PAID_TODO;
  return http.get(url, params);
}

export async function queryPayableObsolete(params) {
  const url = params.customUuid ? incubator.CUSTOM_OBSOLETE : incubator.INCU_PAYABLE_OBSOLETE;
  return http.get(url, params);
}

export async function queryPayablePendingRefund(params) {
  const url = params.customUuid
    ? incubator.CUSTOM_PENDINGREFUND
    : incubator.INCU_PAYABLE_PENDINGREFUND;
  return http.get(url, params);
}

export async function queryPayablePendingRefundTodo(params) {
  return http.get(incubator.CUSTOM_PENDINGREFUND_TODO, params);
}

export async function queryPayableRefunded(params) {
  const url = params.customUuid ? incubator.CUSTOM_REFUND : incubator.INCU_PAYABLE_REFUNDED;
  return http.get(url, params);
}

export async function queryPayableRefund(params) {
  return http.get(incubator.INCU_PAYABLE_REFUND, params);
}

export async function queryPayableStatistics(params) {
  const url = params.customUuid
    ? incubator.CUSTOM_PAYABLE_STATIS
    : incubator.INCU_PAYABLE_STATISTICS;
  return http.get(url, params);
}

export async function queryPayableDetailStatistics(params) {
  const url = params.customUuid
    ? incubator.CUSTOM_PAYABLE_DETAIL_STATIS
    : incubator.PAYABLE_DETAIL_STATISTICS;
  return http.get(url, params);
}

export async function queryPayableDetail(params) {
  return http.get(incubator.INCU_PAYABLE_DETAIL, params);
}

export async function queryPayableConfirm(params) {
  return http.post(incubator.INCU_PAYABLE_CONFIRM, params);
}

export async function queryPayableCancel(params) {
  return http.post(incubator.INCU_PAYABLE_CANCEL, params);
}

/** 待退款提醒 */
export async function queryPayablePendingRefundRemind(params) {
  return http.get(incubator.PAYABLE_PENDINGREFUND_REMIND, params);
}

/** 已到期押金休眠 */
export async function querySavePayableSleep(params) {
  return http.post(incubator.PAYABLE_SLEEP_SAVE, params);
}



// WEBPACK FOOTER //
// ./src/api/incubator/payable.js